import React from 'react'

export default function CloseCircle({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path
        d="M54.629 9.372a32 32 0 100 45.254 32.001 32.001 0 000-45.254zM44.727 41.9a2 2 0 11-2.828 2.828l-9.9-9.9-9.899 9.9a2 2 0 01-2.828-2.828l9.9-9.9-9.9-9.9a2 2 0 012.828-2.827L32 29.17l9.899-9.898a2 2 0 012.828 2.828l-9.9 9.898z"
        fill="currentColor"
      />
    </svg>
  )
}
